import { useList } from "stores/hooks/list";
import { useListEntities } from "stores/hooks/list-entities";
import { StyledNavigation } from "./user-navigation.styles";
import { parse } from "lib/locale";
import { useLocale } from "stores/hooks/locale";
import { useLocation, useParams } from "react-router";
import { ListEntity } from "models/list-entity";
import Breadcrumb, {
  BreadcrumbStage,
  BreadcrumbStageType,
} from "components/breadcrumb";

const UserNavigation = () => {
  const list = useList();
  const { entityUuid } = useParams();
  const { pathname } = useLocation();
  const entities = useListEntities();
  const locale = useLocale();

  if (!list) {
    return null;
  }

  const obligationUrl = pathname.includes("obligation");
  const summaryUrl = pathname.includes("summary");

  const obligatioStage: BreadcrumbStageType = obligationUrl
    ? "current"
    : "past";
  const summaryStage: BreadcrumbStageType = summaryUrl ? "current" : "future";

  // get the entity defined by url
  const currentEntity = entityUuid
    ? entities.find((e) => e.uuid === entityUuid)
    : undefined;

  const parseEntityStage = (entity: ListEntity) => {
    if (obligationUrl) {
      return "future";
    } else if (summaryUrl) {
      return "past";
    } else {
      if (currentEntity && entity.order < currentEntity.order) {
        return "past";
      } else if (currentEntity && entity.order > currentEntity.order) {
        return "future";
      }
    }
    return "current";
  };

  const stages: BreadcrumbStage[] = [];
  if (list.obligation) {
    stages.push({ type: obligatioStage, text: "Velvoitteet" });
  }
  entities.forEach((entity) => {
    const stage = parseEntityStage(entity);
    stages.push({ type: stage, text: parse(entity.name, locale) });
  });
  stages.push({ type: summaryStage, text: "Yhteenveto" });

  return (
    <StyledNavigation>
      <Breadcrumb stages={stages} />
    </StyledNavigation>
  );
};

export default UserNavigation;
